export const replacer = function (string, data) {
  for (const value in data) {
    string = string.replace(new RegExp('{' + value + '}', 'g'), data[value])
  }
  return string
}
